import { render, staticRenderFns } from "./ParameterModal.vue?vue&type=template&id=12dbd4c0&"
import script from "./ParameterModal.vue?vue&type=script&lang=js&"
export * from "./ParameterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12dbd4c0')) {
      api.createRecord('12dbd4c0', component.options)
    } else {
      api.reload('12dbd4c0', component.options)
    }
    module.hot.accept("./ParameterModal.vue?vue&type=template&id=12dbd4c0&", function () {
      api.rerender('12dbd4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ParameterModal.vue"
export default component.exports